<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Tanggal"
                  dense
                  small-chips
                  hide-details
                  type="date"
                  v-model="formData.tgl"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <div class="form-group">
                  <v-text-field
                    label="Jam"
                    dense
                    small-chips
                    hide-details
                    type="time"
                    v-model="formData.jam"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-combobox
                  label="Nama Pelapor"
                  :items="items.karyawan"
                  :loading="loading.karyawan"
                  :disabled="loading.karyawan"
                  v-model="formData.kode_karyawan"
                  dense
                  hide-details
                  ref="karyawan"
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-combobox
                  label="Kategori"
                  :items="items.kategori"
                  :loading="loading.kategori"
                  :disabled="loading.kategori"
                  v-model="formData.kategori"
                  dense
                  hide-details
                  ref="kategori"
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Kode TTPB"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.ttpb"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="KC"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.kc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="KV"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.kv"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="10" class="fit-content">
                <v-text-field
                  label="Deskripsi Kejadian"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.deskripsi_kejadian"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="4" class="fit-content">
              <v-text-field
                label="Remarks Management"
                dense
                small-chips
                hide-details
                type="text"
                v-model="formData.remarks_management"
              ></v-text-field>
            </v-col> -->
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Initial Modal -->
    <FindNoLK :openModal="!haveNoLaporan" @close-modal="setFormData" />
  </div>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

export default {
  name: "ContainerModal",
  props: ["openModal"],
  components: {
    FindNoLK: () => import("@/components/LaporanKejadian/FindNoLK.vue")
  },
  data() {
    return {
      haveNoLaporan: false,
      loading: {
        karyawan: false,
        kategori: false,
        saveData: false
      },
      items: {
        karyawan: [],
        kategori: []
      },
      formData: {
        id: "",
        kode_karyawan: "",
        kategori: "",
        tgl: "",
        jam: "",
        ttpb: "",
        kc: "",
        kv: "",
        deskripsi_kejadian: "",
        remarks_management: ""
      }
    };
  },
  computed: {
    mini: sync("app/mini")
  },
  watch: {
    "formData.ttpb"(val) {
      this.formData.ttpb = val.toUpperCase();
    },
    "formData.kc"(val) {
      this.formData.kc = val.toUpperCase();
    },
    "formData.kv"(val) {
      this.formData.kv = val.toUpperCase();
    }
  },
  methods: {
    setFormData(val) {
      this.haveNoLaporan = true;

      if (val.id) {
        this.formData.id = val.id;
        this.formData.kode_karyawan = val.kode_karyawan;
        this.formData.kategori = val.kategori;
        this.formData.tgl = val.tgl;
        this.formData.jam = val.jam;
        this.formData.ttpb = val.ttpb;
        this.formData.kc = val.kc;
        this.formData.kv = val.kv;
        this.formData.deskripsi_kejadian = val.deskripsi_kejadian;
      }
    },
    async fetchKaryawan() {
      this.loading.karyawan = true;

      await axios
        .get(`karyawan`)
        .then(res => {
          this.items.karyawan = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.karyawan = false;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKategori() {
      this.loading.kategori = true;

      await axios
        .get(`master-data?kategori=kategori_laporan`)
        .then(res => {
          this.loading.kategori = false;
          this.items.kategori = res.data.map(data => data.nama);
        })
        .catch(err => {
          this.loading.kategori = false;

          alert(err.response.data.message);
        });
    },
    async saveData() {
      this.loading.saveData = true;

      await axios
        .post(`laporan-kejadian`, this.formData)
        .then(res => {
          this.loading.saveData = false;

          alert(res.data.message);

          this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;

          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData = {
        kode_karyawan: "",
        kategori: "",
        tgl: "",
        jam: "",
        ttpb: "",
        kc: "",
        kv: "",
        deskripsi_kejadian: "",
        remarks_management: ""
      };

      this.fetchKategori();
    }
  },
  created() {
    this.fetchKategori();
    this.fetchKaryawan();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}

table thead th {
  font-size: 12px !important;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.w-100 {
  width: 100%;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.no-wrap {
  white-space: nowrap;
}

.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}

input[type="time"]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance: none;
  appearance: none;
  margin: -10px;
}
</style>
